import { formatMoneyFromMinorUnits } from '../../../shared/lib/money.js';

function formatDate(value) {
  const raw = String(value || '').trim();
  if (!raw) {
    return '-';
  }

  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) {
    return raw;
  }

  return date.toLocaleString();
}

export function buildTransactionsTableModel(dtoRows) {
  return dtoRows.map((row) => ({
    key: row.key,
    id: row.id,
    transactionNumber: row.transactionNumber,
    profileId: row.profileId,
    profileName: row.profileName,
    type: row.type,
    methodId: row.methodId,
    reference: row.reference,
    amountFormatted: formatMoneyFromMinorUnits(row.amountMinor, row.currency),
    currency: row.currency,
    status: row.status,
    assignedToId: row.assignedToId,
    assignedToName: row.assignedToName,
    accountLogin: row.accountLogin || '-',
    createdAt: formatDate(row.created),
    modifiedAt: formatDate(row.modified),
    source: row.source,
  }));
}
